import { useCallback, useContext, useEffect, useMemo } from 'react';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { isFunction } from 'lodash';
import moment from 'moment';

import { InvoiceContext } from 'components/pages/finance/NewInvoice/NewInvoiceContext';

import { DD_SLASH_MMM_SLASH_YYYY } from '../../../../../../constants/dateFormat';

import './InvoiceDatePicker.scss';
export default function InvoiceDatePicker({ disabled }) {
  const { invoiceDate, setInvoiceDate, invoiceCreationDate, setIsInvalidInvoiceDate } = useContext(InvoiceContext);

  const limits = useMemo(() => {
    const base = moment(invoiceCreationDate);
    return {
      baseDate: base,
      minDate: getBusinessDay(base, -5),
      maxDate: getBusinessDay(base, 5)
    };
  }, [invoiceCreationDate]);

  const shouldDisableDate = useCallback(
    date => {
      const day = date.day();
      const isWeekend = day === 0 || day === 6;
      const isOutside = date.isBefore(limits.minDate, 'day') || date.isAfter(limits.maxDate, 'day');

      return isOutside || (isWeekend && !date.isSame(limits.baseDate, 'day'));
    },
    [limits]
  );

  const isErrorEnabled = useMemo(() => {
    return !invoiceDate || shouldDisableDate(invoiceDate);
  }, [invoiceDate, shouldDisableDate]);

  const onInvoiceDateChange = newValue => {
    if (isFunction(setInvoiceDate)) {
      if (newValue && newValue.isValid()) {
        const eventCreateDate = invoiceCreationDate;

        const dateWithCurrentTime = newValue.clone().set({
          hour: eventCreateDate.hour(),
          minute: eventCreateDate.minute(),
          second: eventCreateDate.second(),
          millisecond: eventCreateDate.millisecond()
        });

        setInvoiceDate(dateWithCurrentTime);
      }
    }
  };

  useEffect(() => {
    setIsInvalidInvoiceDate(isErrorEnabled);
  }, [isErrorEnabled, setIsInvalidInvoiceDate]);

  return (
    <div className="r-ss-wrap">
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DesktopDatePicker
          label="Invoice Date"
          className="invoice-date_picker"
          value={invoiceDate}
          format={DD_SLASH_MMM_SLASH_YYYY}
          onChange={newValue => onInvoiceDateChange(newValue)}
          disabled={disabled}
          shouldDisableDate={shouldDisableDate}
          slotProps={{
            textField: {
              variant: 'standard',
              error: isErrorEnabled
            }
          }}
        />
      </LocalizationProvider>
    </div>
  );
}

function getBusinessDay(startDate, daysToAdd) {
  const date = moment(startDate).clone();
  let count = 0;
  const direction = daysToAdd > 0 ? 1 : -1;
  const absDays = Math.abs(daysToAdd);

  while (count < absDays) {
    date.add(direction, 'days');
    if (date.day() !== 0 && date.day() !== 6) {
      count++;
    }
  }
  return date;
}
